import { combineReducers, createStore, applyMiddleware } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension';
import { createLogicMiddleware } from 'redux-logic';

import { searchCustomersReducer } from './searchCustomers/reducer';
import { searchCompCardsReducer } from './searchCompCards/reducer';
import { searchCustomersLogic } from './searchCustomers/logics';
import {
  searchCompCardsLogic,
  syncAppliedCompCardsLogic,
} from './searchCompCards/logics';
import { contextReducer } from './context/reducer';
import { fetchContextLogic } from './context/logics';
import {
  addCustomerToSaleLogic,
  getCustomerLogic,
  removeCustomerFromSaleLogic,
  smsEnrollLogic,
} from './customer/logics';
import { customerReducer } from './customer/reducer';
import { compDiscountsReducer } from './compDiscounts/reducer';
import { discountsReducer } from './discounts/reducer';
import {
  addDiscountLogic,
  clearDiscountsLogic,
  fetchDiscountsLogic,
  removeDiscountLogic,
  removeDiscountsLogic,
  submitDiscountsLogic,
} from './discounts/logics';
import {
  addCompDiscountLogic,
  clearCompDiscountsLogic,
  fetchCompDiscountsLogic,
  removeCompDiscountLogic,
  removeCompDiscountsLogic,
  submitCompDiscountsLogic,
} from './compDiscounts/logics';
import { barcodeScannerReducer } from './barcodeScanner/reducer';

export const rootReducer = combineReducers({
  barcodeScanner: barcodeScannerReducer,
  context: contextReducer,
  compDiscounts: compDiscountsReducer,
  customer: customerReducer,
  discounts: discountsReducer,
  searchCustomers: searchCustomersReducer,
  searchCompCards: searchCompCardsReducer,
});

const middlewares = [
  createLogicMiddleware([
    addCompDiscountLogic,
    addCustomerToSaleLogic,
    addDiscountLogic,
    clearCompDiscountsLogic,
    clearDiscountsLogic,
    fetchCompDiscountsLogic,
    fetchContextLogic,
    fetchDiscountsLogic,
    getCustomerLogic,
    removeCompDiscountLogic,
    removeCompDiscountsLogic,
    removeCustomerFromSaleLogic,
    removeDiscountLogic,
    removeDiscountsLogic,
    searchCompCardsLogic,
    searchCustomersLogic,
    smsEnrollLogic,
    submitCompDiscountsLogic,
    submitDiscountsLogic,
    syncAppliedCompCardsLogic,
  ]),
];

const middlewareEnhancer = applyMiddleware(...middlewares);

const enhancers = [middlewareEnhancer];
const composedEnhancers = composeWithDevTools(...enhancers);

export const store = createStore(rootReducer, composedEnhancers);
